import React from "react";

// Create a context to hold related data that can be accessed by multiple components
// Avoids having to pass the auth object from App to all child components and potentially through many layers
const AuthContext = new React.createContext();

export default AuthContext;
